import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import NotFoundPage from "./pages/NotFoundPage";
import SynergyConnect from "./pages/SynergyConnect";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SynergyConnect />} />
        <Route path="/:seed" element={<SynergyConnect />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;
